import React, { useCallback } from "react";

import styled from "styled-components/macro";

import { useDismissDashboardCard } from "Dashboard/DashboardCards/API/queries";
import { useCategoryCardContext } from "Dashboard/DashboardCards/DashboardCards";

import FnrIcon from "UI/FnrIcon";

export default function Dismiss() {
  const { ID } = useCategoryCardContext();
  const { mutate: dismissCard } = useDismissDashboardCard();

  const handleDismiss = useCallback(() => dismissCard(ID), [ID, dismissCard]);

  return (
    <Wrapper>
      <Button onClick={handleDismiss} data-cy="DashboardCards_DismissButton">
        <FnrIcon fas fa-times-circle />
      </Button>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: absolute;
  z-index: 500;
  top: 4px;
  left: 4px;
`;

const Button = styled.button`
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  appearance: none;
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  color: ${(props) => props.theme.colors.white};
  opacity: 0.8;
  font-size: 18px;
  transition: opacity 0.2s, transform 0.2s;

  &:hover {
    cursor: pointer;
    transform: scale(1.05);
  }
  &:active {
    transform: scale(0.95);
  }
`;
